@if (componentData$ | async; as data) {
  <p [innerHTML]="data.content | safe: 'html'"></p>
}
